module.exports = __webpack_public_path__ + "static/renee-0e776785fe8874c2d520841e6d340586.png";